import WorkerDetailsCard from "./WorkerDetailsCard";

export default WorkerDetailsCard;
